import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AEB30C8D-5159-4897-8D17-6EFB9715D3CD
 * name hazard-lights
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hazard-lights.svg
 * tags
 * - Automotive 
 */
export const HazardLightsIcon = createSvgIcon(<><path d="M12,12L14.33,16H9.68L12,12M12,8L6.21,18H17.8L12,8M12,2L1,21H23L12,2M12,6L19.53,19H4.47L12,6Z" /></>, 'HazardLightsIcon');
export default HazardLightsIcon